import React from "react";
import classes from "./StepTileList.module.scss";
import Tile from "../Tile";
import { tileTypes } from "../../../../utils/tileTypes";
import { tileSize } from "../../../../utils/tileSizes";
import StepNextArrowIcon from "../../SvgIcons/CommonIcons/StepNextArrowIcon";

const StepTileList = ({
  data,
  type = tileTypes.DEFAULT,
  size = tileSize.DEFAULT,
}) => {
  
  const primaryColor = JSON.parse(localStorage.getItem("themeData")).CustomData
    .PrimaryColor1;

  return (
    <div
      className={
        data?.length === 2 ||
        data?.filter((filterItem) => filterItem?.hidden)?.length === 2 
          ? classes.stepTileList2
          : classes.stepTileList
      }
    >
      {data?.map((item, index) => {
        if (!item?.hidden) {
          return (
            <React.Fragment key={item.key}>
              <Tile
                key={item.key}
                value={item.item}
                label={item.label}
                stripeColor={item.color}
                size={size}
                type={type}
                smallTileIcon={item.icon}
                defaultTileicon={item.optionalText}
                width={size === tileSize.LARGE ? "32.5rem" : "24rem"}
                isCompleted={item.isCompleted}
                path={item.path}
              />
              {parseInt(index) !== parseInt(data.length - 1) && (
                <div className={classes.stepnextArrow}>
                  <StepNextArrowIcon fill={item.isCompleted && primaryColor} />
                </div>
              )}
            </React.Fragment>
          );
        }
      })}
    </div>
  );
};

export default StepTileList;
